import { useTranslation } from 'react-i18next';
import { ConditionnalPage } from '../components/atoms/ConditionnalPageContainer';
import { ErrorOrSuccessBlock } from '../components/molecules/ErrorOrSuccessBlock';
import { localizeUrl } from '../utils/tools';

export const NotFoundPage = ({ isPage = true }: ConditionnalPage) => {
  const {
    t
  } = useTranslation();

  return (
    <ErrorOrSuccessBlock
      title={t('pageNotFound.title')}
      text={t('pageNotFound.text')}
      buttonLabel={t('pageNotFound.goToHomepage').toUpperCase()}
      isContainedButton={true}
      to={localizeUrl('/')}
      isPage={isPage}
    />
  );
};

export default NotFoundPage;
